import { Browser } from '@capacitor/browser';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

export type ClickAction =
  | { kind: 'external'; url: string }
  | { kind: 'download'; url: string; name: string }
  | null;

const fileName = (url: URL) => decodeURIComponent(url.pathname.split('/').pop() || '') || 'файл';

/**
 * Чужой сайт — в Safari. Свой файл (скачивание или новая вкладка) — через
 * «Поделиться»: в Safari нашего входа нет, файл бы там не открылся.
 */
export function classifyClick(a: HTMLAnchorElement | null, origin: string): ClickAction {
  if (!a?.href) return null;
  const url = new URL(a.href, origin);
  if (url.protocol !== 'http:' && url.protocol !== 'https:' && url.protocol !== 'blob:') return null;
  if (url.protocol !== 'blob:' && url.origin !== origin) return { kind: 'external', url: url.href };
  if (a.hasAttribute('download') || a.target === '_blank') {
    return { kind: 'download', url: url.href, name: a.getAttribute('download') || fileName(url) };
  }
  return null;
}

const toBase64 = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1] ?? '');
    r.onerror = () => reject(r.error);
    r.readAsDataURL(blob);
  });

/** Скачать файл своим входом и отдать системному листу «Поделиться». */
export async function shareFile(url: string, name: string): Promise<void> {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) throw new Error(`Файл не скачался: ${res.status}`);
  const { uri } = await Filesystem.writeFile({
    path: name.replace(/[/\\:]/g, '_'),
    data: await toBase64(await res.blob()),
    directory: Directory.Cache,
  });
  await Share.share({ files: [uri] });
}

export function installLinkHandler(): () => void {
  const onClick = (e: MouseEvent) => {
    const act = classifyClick((e.target as Element | null)?.closest('a') ?? null, location.origin);
    if (!act) return;
    e.preventDefault();
    const done = act.kind === 'external' ? Browser.open({ url: act.url }) : shareFile(act.url, act.name);
    done.catch((err) => console.warn('[app] ссылка', err));
  };
  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
}
